<template>
    <div class="box">
        <div class="header">
            <!--@click="routerPush"-->

            
            <img v-if="!PresentType" src="../../assets/img/scan-black.png" @click='startRecognize' />
        </div>

        <div class="swiperBox">
            <van-swipe :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="(item, index) in banner" :key="index">
                    <img :src="item.src" @click="router()" />
                </van-swipe-item>
            </van-swipe>
        </div>

        <van-popup v-model="ScanShow" position="bottom" :style="{ width: '100%', height: '100%' }">
            <div class="Scan">
                <div class="Header">
                    <img src="../../assets/img/left.png" @click="ScanClose">
                    <span>资产扫码</span>
                </div>
                <div id="bcid" :style='{ zIndex: zIndex }'></div>
            </div>
        </van-popup>

        <div>
            <div class="parent" v-if="item.Content.length !== 0" v-for="item in $store.getters.HomeDesktop">
                <div class="span">
                    <span>{{ item.Title }}</span>
                </div>
                <br />
                <div class="child" v-for="psc in item.Content" @click="itemClick(psc)">
                    <img :src="!!psc.icon ? require(`@/assets/img/${psc.icon}`) : require('@/assets/img/property.png')">
                    <p>{{ psc.name }}</p>
                </div>
            </div>
        </div>

        <!--第一层选择器-->
        <van-action-sheet v-model="show" @select="select" :actions="actions" cancel-text="取消" close-on-click-action />
        <!--第二层选择器     主要用于比如预防性维护根据设备编号多个预防性计划-->
        <van-action-sheet v-model="showSecond" @select="selectSecond" :actions="actionsSecond" cancel-text="取消"
            close-on-click-action />
        <transition name="fade">
            <van-popup v-model="TrainShow" round position="bottom" :style="{ width: '100%', height: '50%' }">
                <div class="SignInSuccess" v-if="TrainIconShow">
                    <img src="../../assets/img/signIn.png" />
                    <h1>签到成功</h1>
                </div>
            </van-popup>
        </transition>
        <div style="margin-top:30px;"></div>
    </div>
</template>
<script>
import * as indexConfig from '../../../config/index.js'
import {
    Popup,
    Swipe,
    SwipeItem,
    ActionSheet,
} from 'vant'
import {
    LoadJurisdiction
} from '../../../tool/permission.js'
import Vue from 'vue'
import {
    ExistsEdorIng,
    GetSystemParameter
} from '../../../tool/api/api.js'
export default {
    name: 'Home',
    data() {
        return {
            ScanShow: false,
            scan: '', //扫码实体
            zIndex: -1, //扫码层级
            PresentType: indexConfig.PresentType, //是否展示扫码功能
            url: 'record.png',
            showSecond: false, //第二层选择器是否显示
            actionsSecond: [], //第二层选择器列表
            actionsSecondArray: [], //第二层原始集合
            banner: [
                //  src 图片地址    router 跳转链接
                {
                    src: '../../static/Home_1.png',
                    router: ''
                },
                {
                    src: '../../static/Home_2.png',
                    router: ''
                }
            ],
            //  是否显示扫码提示框
            show: false,
            //  扫码提示框选项
            actions: [{
                name: '资产信息',
                state: 1
            }, {
                name: '资产档案',
                state: 2
            }, {
                name: '资产报修',
                state: 3
            }, {
                name: '资产转科',
                state: 4
            }, {
                name: '资产报废',
                state: 5
            }, {
                name: '预防性维护',
                state: 6
            }, {
                name: '保养实施',
                state: 7
            }],
            overlayshow: true,
            TrainShow: false, //是否显示弹出框
            TrainIconShow: false, //是否显示签到成功
        }
    },
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [ActionSheet.name]: ActionSheet,
        [Popup.name]: Popup
    },
    mounted() {
        if (!Vue.prototype.$UserInfo && localStorage.getItem('userInfo')) Vue.prototype.$UserInfo = JSON.parse(
            localStorage.getItem('userInfo')); //切换用户重新赋值当前登陆人全局对象
        //扫码签到
        if (this.$route.query.PXHYBH) {
            this.TrainShow = true;
            this.$get('api/Property/TrainSignIn', {
                PXHYBH: this.$route.query.PXHYBH,
                GKHM: this.$UserInfo.UserId
            }).then(result => {
                if (result.Status) {
                    this.TrainIconShow = true;
                } else {
                    this.$Toast(result.Msg);
                }
            })
            return false;
        }

        //如果是通过扫码进入 显示选项卡
        if (!!this.$route.query.SBBH) {
            this.show = true;
            this.$store.commit('SET_EQUIPMENTID', this.$route.query.SBBH);
        }
        this.loadDataDefault();
    },

    methods: {
        itemClick(item) { //选择进入api管理再进行跳转还是直接跳转
            !item.url ? this.$Toast("系统异常,请联系管理员!") : item.name == '维修处理' ? GetSystemParameter() : this.$router
                .push(item.url);
        },
        loadDataDefault() {
            if (this.$store.getters.HomeDesktop.length === 0) { //Home页面取自VUE状态管理
                this.$get('api/Login/GetHomePageForH5', {
                    GKHM: this.$UserInfo.UserId,
                }, 20000).then(result => {
                    result.push({
                        Title: '审批管理',
                        Content: [{
                            icon: 'judge.png',
                            name: '多级审批',
                            url: '/examineList'
                        }]
                    }); //审批管理
                    this.$store.commit('SET_HOMEDESKTOP', result);
                })
            }
        },
        router() {
            // window.location.href='http://www.baidu.com';
        },
        select(obj) {
            switch (obj.state) {
                case 1: //资产信息
                    this.$post('api/Repair/PropertyQueryForAPP', {
                        SB: this.$store.getters.EquipmentId,
                        KS: '',
                        User: this.$UserInfo.UserId,
                        Store: this.$UserInfo.StoreCode,
                        PageIndex: 1,
                        PageSize: 1,
                        IsUse: '',
                    }).then(result => {
                        if (result.PropertyList.length !== 0) {
                            this.$router.push({
                                name: 'PropertyDetails',
                                params: {
                                    item: result.PropertyList[0],
                                    pageState: false
                                }
                            })
                        } else {
                            this.$Toast('您没有此科室权限，请联系管理员！');
                        }
                    })
                    break;
                case 2: //资产档案
                    this.$post('api/Repair/PropertyQueryForAPP', {
                        SB: this.$store.getters.EquipmentId,
                        KS: '',
                        User: this.$UserInfo.UserId,
                        Store: this.$UserInfo.StoreCode,
                        PageIndex: 1,
                        PageSize: 1,
                        IsUse: '',
                    }).then(result => {
                        if (result.PropertyList.length !== 0) {
                            this.$router.push({
                                name: 'PropertyUploadImg',
                                params: {
                                    item: result.PropertyList[0],
                                    pageState: true
                                }
                            })
                        } else {
                            this.$Toast('您没有此科室权限，请联系管理员！');
                        }
                    })
                    break;
                case 3: //资产报修
                    this.$post('api/Repair/PropertyQueryForAPP', {
                        SB: this.$store.getters.EquipmentId,
                        KS: '',
                        User: this.$UserInfo.UserId,
                        Store: this.$UserInfo.StoreCode,
                        PageIndex: 1,
                        PageSize: 1
                    }).then(result => {
                        if (result.PropertyList.length !== 0) {
                            if (result.PropertyList[0].EquState == '0') {
                                this.$Toast('此资产不是在用状态,无法报修!')
                            } else {
                                this.$router.push({
                                    name: 'Repairs',
                                    params: {
                                        item: result.PropertyList[0]
                                    }
                                });
                            }
                        }
                        else {
                            this.$Toast('您没有此科室权限，请联系管理员！')
                        }
                    });
                    break;
                case 4: //资产转科
                    this.$post('api/Repair/PropertyQueryForAPP', {
                        SB: this.$store.getters.EquipmentId,
                        KS: '',
                        User: this.$UserInfo.UserId,
                        Store: this.$UserInfo.StoreCode,
                        PageIndex: 1,
                        PageSize: 1
                    }).then(result => {
                        if (result.PropertyList.length !== 0) {
                            if (result.PropertyList[0].EquState == '0') {
                                this.$Toast('此资产不是在用状态,无法转科!');
                            } else {
                                this.$router.push({
                                    name: 'ChangeDepartment',
                                    params: {
                                        item: result.PropertyList[0],
                                        pageState:true
                                    }
                                });
                            }
                        }
                        else { this.$Toast('您没有此科室权限，请联系管理员！'); }
                    })
                    break;
                case 5: //资产报废
                    this.$post('api/Repair/PropertyQueryForAPP', {
                        SB: this.$store.getters.EquipmentId,
                        KS: '',
                        User: this.$UserInfo.UserId,
                        Store: this.$UserInfo.StoreCode,
                        PageIndex: 1,
                        PageSize: 1
                    }).then(result => { //
                        if (result.PropertyList.length !== 0) {
                            if (result.PropertyList[0].EquState == '0') {
                                this.$Toast('此资产不是在用状态,无法报废!');
                            } else {
                                this.$router.push({
                                    name: 'Scrap',
                                    params: {
                                        item: result.PropertyList[0],
                                        pageState: true
                                    }
                                });
                            }
                        }
                        else { this.$Toast('您没有此科室权限，请联系管理员！'); }
                    })
                    break;
                case 6: //预防性维护
                    this.$post('api/YF/BYList', {
                        Store: this.$UserInfo.StoreCode,
                        UserCode: this.$UserInfo.UserId,
                        EquName: this.$store.getters.EquipmentId, //设备名称
                        StartDate: '', //开始
                        EndDate: '', //结束
                        SYKS: '', //科室
                        PageIndex: 1,
                        PageSize: 10
                    }).then(result => {
                        if (result.BYList.length === 0) {
                            this.$Toast('未找到预防计划,请先制定计划');
                        } else if (result.BYList.length === 1) {
                            ExistsEdorIng(1, 'Y', 'QualityTest', result.BYList[0]);
                        } else if (result.BYList.length > 1) {
                            this.actionsSecondArray = result.BYList;
                            let that = this;
                            result.BYList.forEach(function (item, index) {
                                that.actionsSecond.push({
                                    name: item.EquName + '(计划名称:' + item.OrderName + ')',
                                    state: 1,
                                    JHDH: item.OrderNo
                                });
                            })
                            that.show = false;
                            that.showSecond = true;
                        }
                    })
                    break;
                case 7: //设备保养
                    this.$get('api/BY/GetUpkeepBySBBH', {
                        SBBH: this.$store.getters.EquipmentId
                    }).then(result => {
                        result = JSON.parse(result);
                        this.actionsSecondArray = result;
                        if (result.length === 0) {
                            this.$Toast('未找到保养计划,请先制定计划');
                            this.show = false;
                        } else if (result.length === 1) {
                            ExistsEdorIng(2, 'Y', 'MaintainImplementDefault', result[0]);
                        } else {
                            for (let i = 0; i < result.length; i++) {
                                this.actionsSecond.push({
                                    name: result[i].SBMC + '(计划名称:' + result[i].JHMC + ')',
                                    JHDH: result[i].JHDH,
                                    state: 2
                                })
                            }
                        }
                    })
                    break;

            }
        },
        selectSecond(obj) { //第二层选择器的选择事件
            if (obj.state === 1) { //预防性维护
                ExistsEdorIng(1, 'Y', 'QualityTest', this.actionsSecondArray.find(x => x.OrderNo === obj.JHDH));
            } else if (obj.state === 2) {
                ExistsEdorIng(2, 'Y', 'MaintainImplementDefault', this.actionsSecondArray.find(x => x.JHDH === obj
                    .JHDH));
            }
        },
        startRecognize() {
            try {
                LoadJurisdiction({
                    Android: 'android.permission.CAMERA',
                    Ios: 'camera',
                    Message: '请在权限管理赋予APP摄像头权限',
                }).then(() => {
                    //初始化扫描
                    this.ScanShow = true;
                    this.zIndex = 2004;
                    this.$Toast({
                        message: '正在加载...',
                        duration: 0
                    });
                    setTimeout(() => {
                        let that = this;
                        if (!window.plus) {
                            return
                        };
                        // 初始化扫描控件
                        this.scan = new plus.barcode.Barcode('bcid');
                        this.scan.onmarked = onmarked;
                        // 调用开始扫描
                        this.startScan()
                        // 扫描后回调
                        function onmarked(type, result, file) {
                            switch (type) {
                                case plus.barcode.QR:
                                    type = 'QR';
                                    break;
                                case plus.barcode.EAN13:
                                    type = 'EAN13';
                                    break;
                                case plus.barcode.EAN8:
                                    type = 'EAN8';
                                    break;
                                default:
                                    type = '其它' + type;
                                    break;
                            }
                            result = result.replace(/\n/g, '');
                            var index = result.indexOf('SBBH=');
                            if (index != -1) {
                                result = result.substring(index + 5, result.indexOf(
                                    '&')); //得到路径中的设备编号
                            }

                            if (result) {
                                that.$get('api/property/ExistsEquipment', {
                                    SBBH: result
                                }).then(res => {
                                    // console.log('扫码结果', JSON.stringify(res));
                                    if (res == "Y") {
                                        that.show = true;
                                        that.$store.commit('SET_EQUIPMENTID', result);
                                    } else
                                        that.$Toast('未找到设备信息,请扫描正确的资产条形码或二维码!');
                                    that.ScanClose();
                                })
                            } else {
                                that.$Toast('请扫描正确的设备条形码或二维码!');
                                that.ScanClose();
                            }
                        }
                    }, 600)
                })
            } catch (e) {
                this.ScanClose();
                console.log(e);
            }
        },
        startScan() { //开始扫描
            if (!window.plus) return;
            this.scan.start();
            this.$Toast.clear();
        },
        closeScan() { //关闭条码识别控件
            if (!window.plus) return;
            this.scan.cancel();
            this.scan.close();
        },
        ScanClose() { //关闭扫码
            this.closeScan();
            this.ScanShow = false;
        },
        routerPush() {
            this.$router.push({
                name: 'Test'
            });
        }
    },
    watch: {
        $route(to, from) { //监听路由跳转预防和保养关闭模态框
            if ((to.name === 'QualityTest' || to.name === 'MaintainImplementDefault') && from.name === 'Home') {
                this.showSecond = false
            }
        },
        TrainShow(newValue, oldValue) {
            if (oldValue === true && newValue === false) {
                this.loadDataDefault();
            }
        }
    }
}
</script>

<style scoped lang="scss">
.box {
    padding-bottom: 80px;
}

.header {
    .van-swipe-item {
        text-align: center;
    }

    img {
        position: absolute;
        width: 52px;
        height: 52px;
        right: 40px;
        top: 12px;
    }
}

.swiperBox {
    margin: 118px 20px 0;
    width: 710px;
    height: 300px;
    border-radius: 26px;
    overflow: hidden;
    // -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);

    img {
        height: 300px;
    }
}

.content {
    margin-top: 56px;
    display: flex;
    flex-wrap: wrap;
    padding: 0 26px 0 28px;
    box-sizing: border-box;

    .items {
        width: 25%;
        text-align: center;
        margin-bottom: 58px;

        img {
            width: 84px;
            height: 84px;
        }

        p {
            font-size: 26px;
            color: $TEXT-DARK-COLOR;
            margin-top: 22px;
        }
    }
}

.parent {
    .span {
        margin: 30px 0 0 15px;
        font-weight: 700;
    }

    .child {
        text-align: center;
        display: inline-block;
        width: 25%;

        img {
            width: 84px;
            height: 84px;
        }

        p {
            font-size: 26px;
        }
    }
}

.SignInSuccess {
    height: 100%;

    img {
        width: 100px;
        height: 100px;
        display: block;
        margin: 0 auto;
        margin-top: 40%;
    }

    h1 {
        font-size: 40px;
        font-weight: 600;
        text-align: center;
    }
}

.fade-enter-active,
//上拉下拉柔顺加载
.fade-leave-active {
    transition: opacity 1s
}

.fade-enter,
.fade-leave-active {
    opacity: 0
}


.Scan {
    .Header {
        height: 14.133vw;
        background-color: #4FA69E;
        color: #FFFFFF;

        img {
            position: absolute;
            left: 1.067vw;
            width: 6.933vw;
            top: 0.8vw;
            padding: 2.667vw;
        }

        span {
            color: #fff;
            font-size: 4.533vw;
            font-weight: 400;
            position: absolute;
            top: 2%;
            left: 42%;
        }
    }

    #bcid {
        height: 100%;
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/home/home.vue